import { useTheme } from 'styled-components';
import { useMemo } from 'react';

import { OrderStatus } from '@dreryk/egabinet-statistics-frontend-api';

import { Message } from '@dreryk/react-components';

import { getStatusLabel } from './StatusCell.utils';

type StatusCellProps = {
   status: OrderStatus;
};

export const StatusCell = (props: StatusCellProps): JSX.Element => {
   const theme = useTheme();
   const options = useMemo(
      () => ({
         READY: {
            color: theme.success,
            backgroundColor: theme.successLighter,
         },
         IN_PROGRESS: {
            color: theme.info,
            backgroundColor: theme.infoLighter,
         },
         FAILED: {
            color: theme.error,
            backgroundColor: theme.errorLighter,
         },
      }),
      [theme]
   );
   return (
      <Message
         displayIndicator
         type={props.status}
         options={options}
         label={getStatusLabel(props.status)}
         testId={'statisticsStatus'}
      />
   );
};
